export const environment = {
  production: false,
  useEmulators: false,
  version: '1.1.10',
  languages: [
    { code: 'es', name: 'Español' },
    { code: 'en', name: 'English' }
  ],
  firebaseConfig: {
    apiKey: "AIzaSyAifZNvfA_aaYY4l5qStLz-QdeDR9tQ_6s",
    authDomain: "resi-connect-dev.firebaseapp.com",
    projectId: "resi-connect-dev",
    storageBucket: "resi-connect-dev.firebasestorage.app",
    messagingSenderId: "814003197544",
    appId: "1:814003197544:web:2d422ae8707a3787a88ddd",
    measurementId: "G-B2G8H2W4RG"
  }
};